// ============================================================================
// URL de compra de Shopify.
// Reemplazá el valor de SHOPIFY_URL por la URL exacta de tu producto o
// checkout de Shopify (ej: "https://mitienda.myshopify.com/products/basta-de-sostenerlo-todo").
// TODOS los botones de compra de la página usan esta única constante.
// ============================================================================
export const SHOPIFY_URL =
  'https://vskr1a-08.myshopify.com/cart/add?id=59627726569758&quantity=1'

export const SITE = {
  brand: 'RESPIRA',
  footer: 'www.respiratranquilidad.com · © 2026',
}
